import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		defaultMessage: 'Your work',
		id: 'atlassian-navigation.your-work-dropdown.title',
		description: 'Title of the Your Work menu item.',
	},
});
